import React from 'react';
import { Container, Row, Col, Card, Table, Carousel } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaRupeeSign, FaMountain, FaWater, FaTree, FaSun, FaCloudSun, FaRoad } from 'react-icons/fa';

const defaultCars = [
  { type: 'SEDAN', oneWay: 15, roundTrip: 14 },
  { type: 'ETIOS', oneWay: 16, roundTrip: 15 },
  { type: 'MUV', oneWay: 20, roundTrip: 19 },
  { type: 'INNOVA', oneWay: 21, roundTrip: 20 },
  { type: 'CRYSTA', oneWay: 24, roundTrip: 23 }
];

const PopularRoutes = () => {
  const navigate = useNavigate();

  const handleBookRoute = (route) => {
    navigate('/', {
      state: {
        pickupLocation: route.from,
        dropLocation: route.to
      }
    });
  };

  const routes = [
    {
      from: 'Kanyakumari',
      to: 'Chennai',
      icon: <FaCloudSun />,
      images: ['/images/routess/kanniyakumari-to-chennai.jpg'],
      description: 'Southern tip to the capital - Comfortable coastal journey',
      distance: '705 km',
      cars: defaultCars
    },
    {
      from: 'Chennai',
      to: 'Kodaikanal',
      icon: <FaMountain />,
      images: ['/images/routess/Chennai-to-Kodaikanal.jpg'],
      description: 'Princess of Hill Stations - Scenic beauty & pleasant climate',
      distance: '525 km',
      cars: defaultCars
    },
    {
      from: 'Chennai',
      to: 'Coimbatore',
      icon: <FaSun />,
      images: ['/images/routess/Chennai-to-Coimbatore.jpg'],
      description: 'Capital to textile city - Smooth highway ride',
      distance: '521 km',
      cars: defaultCars
    },
    {
      from: 'Chennai',
      to: 'Tenkasi',
      icon: <FaRoad />,
      images: ['/images/routess/Chennai-to-Tenkasi.jpg'],
      description: 'Temple town journey - Comfortable outstation travel',
      distance: '650 km',
      cars: defaultCars
    },
    {
      from: 'Chennai',
      to: 'Rameswaram',
      icon: <FaWater />,
      images: ['/images/routess/Chennai-to-Rameswaram.jpg'],
      description: 'Pilgrimage route to the sacred island town',
      distance: '580 km',
      cars: defaultCars
    },
    {
      from: 'Kanyakumari',
      to: 'Bangalore',
      icon: <FaTree />,
      images: ['/images/routess/Kanyakumari-to-Bangalore.jpg'],
      description: 'South tip to IT capital - Long comfortable ride',
      distance: '650 km',
      cars: defaultCars
    },
    {
      from: 'Kanyakumari',
      to: 'Coimbatore',
      icon: <FaMountain />,
      images: ['/images/routess/Kanyakumari-to-Coimbatore.jpg'],
      description: 'Coastal tip to western Tamil Nadu hub',
      distance: '475 km',
      cars: defaultCars
    },
    {
      from: 'Kanyakumari',
      to: 'Madurai',
      icon: <FaSun />,
      images: ['/images/routess/Kanyakumari-to-Madurai.jpg'],
      description: 'Temple city connection from the southern tip',
      distance: '250 km',
      cars: defaultCars
    },
    {
      from: 'Kanyakumari',
      to: 'Rameswaram',
      icon: <FaWater />,
      images: ['/images/routess/Kanyakumari-to-Rameswaram.jpg'],
      description: 'Two sacred destinations in one comfortable trip',
      distance: '305 km',
      cars: defaultCars
    },
    {
      from: 'Coimbatore',
      to: 'Tiruvannamalai',
      icon: <FaMountain />,
      images: ['/images/routess/Coimbatore-to-Tiruvannamalai.jpg'],
      description: 'Spiritual journey to the holy mountain town',
      distance: '365 km',
      cars: defaultCars
    },
    {
      from: 'Madurai',
      to: 'Vellore',
      icon: <FaRoad />,
      images: ['/images/routess/Madurai-to-Vellore.jpg'],
      description: 'Temple city to fort city - Reliable outstation cab',
      distance: '400 km',
      cars: defaultCars
    },
    {
      from: 'Ernakulam',
      to: 'Trichy',
      icon: <FaTree />,
      images: ['/images/routess/Ernakulam-to-Trichy.jpg'],
      description: 'Kerala to Tamil Nadu - Interstate drop taxi',
      distance: '390 km',
      cars: defaultCars
    },
    {
      from: 'Rameswaram',
      to: 'Pondicherry',
      icon: <FaWater />,
      images: ['/images/routess/Rameswaram-to-Pondicherry.jpg'],
      description: 'Island pilgrimage to French coastal town',
      distance: '420 km',
      cars: defaultCars
    },
    {
      from: 'Rameswaram',
      to: 'Thiruvananthapuram',
      icon: <FaCloudSun />,
      images: ['/images/routess/Rameswaram-to-Thiruvananthapuram.jpg'],
      description: 'Cross-state comfort ride to Kerala capital',
      distance: '385 km',
      cars: defaultCars
    },
    {
      from: 'Thanjavur',
      to: 'Tirupati',
      icon: <FaSun />,
      images: ['/images/routess/Thanjavur-to-Tirupati.jpg'],
      description: 'Temple to temple - Devotional outstation trip',
      distance: '391 km',
      cars: defaultCars
    },
    {
      from: 'Thiruvananthapuram',
      to: 'Coimbatore',
      icon: <FaRoad />,
      images: ['/images/routess/Thiruvananthapuram-to-Coimbatore.jpg'],
      description: 'Kerala capital to textile city - Smooth interstate travel',
      distance: '520 km',
      cars: defaultCars
    }
  ];

  return (
    <div className="fade-in py-5">
      <Container>
        <h1 className="text-center mb-5" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.5rem)' }}>
          <span className="text-warning">Popular</span> Routes
        </h1>

        <Row>
          {routes.map((route, index) => (
            <Col lg={6} key={index} className="mb-4">
              <Card className="border-0 shadow h-100" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                {/* Route Image carousel — auto scroll, 16:9 */}
                <div className="route-card-carousel" style={{ aspectRatio: '16 / 9', width: '100%', overflow: 'hidden' }}>
                  <Carousel
                    interval={3500}
                    indicators={route.images.length > 1}
                    controls={route.images.length > 1}
                    pause="hover"
                    fade
                  >
                    {route.images.map((img, imgIndex) => (
                      <Carousel.Item key={imgIndex}>
                        <img
                          src={img}
                          alt={`${route.from} to ${route.to} ${imgIndex + 1}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: 'block',
                            aspectRatio: '16 / 9'
                          }}
                          loading={imgIndex === 0 ? 'eager' : 'lazy'}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </div>

                <Card.Body className="p-4">
                  {/* Route Header with Icon */}
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-warning text-dark rounded-circle p-2 me-3" style={{ 
                      width: '50px', 
                      height: '50px', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center' 
                    }}>
                      <span className="fs-4">{route.icon}</span>
                    </div>
                    <div>
                      <h4 className="fw-bold mb-1" style={{ fontSize: '1.3rem' }}>
                        {route.from} → {route.to}
                      </h4>
                      <p className="text-secondary mb-0 small">{route.description}</p>
                    </div>
                  </div>

                  {/* Distance Badge */}
                  <div className="mb-3">
                    <span className="badge bg-dark text-warning px-3 py-2" style={{ fontSize: '0.9rem' }}>
                      Distance: {route.distance}
                    </span>
                  </div>

                  {/* Fare Table */}
                  <div className="table-responsive">
                    <Table bordered hover className="mb-0 text-center align-middle">
                      <thead>
                        <tr>
                          <th>Car Type</th>
                          <th>One Way</th>
                          <th>Round Trip</th>
                        </tr>
                      </thead>
                      <tbody>
                        {route.cars.map((car, carIndex) => (
                          <tr key={carIndex}>
                            <td className="fw-bold">{car.type}</td>
                            <td>
                              <FaRupeeSign className="me-1" size={12} />
                              {car.oneWay}/km
                            </td>
                            <td>
                              <FaRupeeSign className="me-1" size={12} />
                              {car.roundTrip}/km
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  {/* Book Now Button — prefill From/To on home booking form */}
                  <div className="mt-3 text-center">
                    <button
                      type="button"
                      className="btn btn-warning fw-bold px-4 py-2"
                      style={{ borderRadius: '10px' }}
                      onClick={() => handleBookRoute(route)}
                    >
                      Book This Route
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      <style>{`
        .route-card-carousel .carousel,
        .route-card-carousel .carousel-inner,
        .route-card-carousel .carousel-item {
          height: 100%;
        }
        .route-card-carousel .carousel-indicators {
          margin-bottom: 0.4rem;
        }
        .route-card-carousel .carousel-indicators [data-bs-target] {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #FFD700;
        }
        .route-card-carousel .carousel-control-prev,
        .route-card-carousel .carousel-control-next {
          width: 12%;
          opacity: 0.75;
        }
        .table thead th {
          background-color: #ffc107 !important;
          color: #000;
          font-weight: 600;
          border: none;
        }
        .table td {
          vertical-align: middle;
        }
      `}</style>
    </div>
  );
};

export default PopularRoutes;
